export default __webpack_public_path__ + "static/media/two-heads-new-crop.17a7d931.jpg";